import React from 'react';
import classNames from 'classnames';
import ResolveImage from 'components/ResolveImage';
import StatusBadge from 'router/subrouters/Dash/subrouters/Business/pages/Businesses/components/StatusBadge';
import LinkIcon from 'icons/Link.icon';
import { XOR } from 'types';
import { Button } from 'ncoded-component-library';
import { DropzoneFile } from 'components/Dropzone/utils';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import { NEW_WINDOW_PROPS } from 'data/global';

import './AdvertisingBusinessCard.styles.scss';
import './AdvertisingBusinessCard.styles.responsive.scss';

type AdvertisingBusinessCardLinkProps = {
  link: string;
};

type AdvertisingBusinessCardClickProps = {
  onClick: () => void;
};

export type AdvertisingBusinessCardProps = {
  className?: string;
  title: string;
  description: string;
  coverPhoto: DropzoneFile;
  logoImage: DropzoneFile;
  ctaText: string;
  onlyMobileView?: boolean;
} & XOR<AdvertisingBusinessCardLinkProps, AdvertisingBusinessCardClickProps>;

const AdvertisingBusinessCard: React.FC<AdvertisingBusinessCardProps> = (
  props,
) => {
  const {
    className,
    description,
    title,
    coverPhoto,
    link,
    logoImage,
    ctaText,
    onClick,
    onlyMobileView,
  } = props;
  const { url: imageSrc } = coverPhoto || { url: '' };
  const { url: logoSrc } = logoImage || { url: '' };

  const classes = classNames(
    'advertising-business-card',
    { 'apply-responsive': onlyMobileView },
    className,
  );

  return (
    <div className={classes} onClick={() => onClick?.()}>
      <div className="advertising-business-card__title-section">
        <StatusBadge sponsored />
        <p>{title}</p>
      </div>
      <div className="advertising-business-card__image-container">
        {link ? (
          <a
            href={link}
            aria-label="Advertisement"
            className="advertising-business-card__gallery-img"
            {...NEW_WINDOW_PROPS}
          >
            <ResolveImage src={getImgUrl(imageSrc, RESIZED_WIDTH[240])} />
          </a>
        ) : (
          <div
            aria-label="Advertisement"
            className="advertising-business-card__gallery-img"
          >
            <ResolveImage src={getImgUrl(imageSrc, RESIZED_WIDTH[240])} />
          </div>
        )}
      </div>
      <p className="advertising-business-card__description">{description}</p>
      <div className="advertising-business-card__cta-container">
        {link ? (
          <a href={link} {...NEW_WINDOW_PROPS}>
            <LinkIcon />
            {ctaText}
          </a>
        ) : (
          <Button>
            <LinkIcon />
            {ctaText}
          </Button>
        )}
      </div>
      <div className="advertising-business-card__logo-container">
        {link ? (
          <a
            href={link}
            aria-label="Advertisement"
            className="advertising-business-card__logo-image-container"
            {...NEW_WINDOW_PROPS}
          >
            <ResolveImage src={getImgUrl(logoSrc, RESIZED_WIDTH[240])} />
          </a>
        ) : (
          <div
            aria-label="Advertisement"
            className="advertising-business-card__logo-image-container"
          >
            <ResolveImage src={getImgUrl(logoSrc, RESIZED_WIDTH[240])} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AdvertisingBusinessCard;
